// assets/buy-it-with-slider.js
(function() {
  var initSlick = function() {
    // Check if jQuery and Slick are available
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      var $slider = jQuery('.buy-it-with-slider');
      console.log("Seprate code works");
      // Destroy existing slider if initialized
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      
      if ($slider.length) {
        $slider.slick({
          dots: true,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                dots: true
              }
            }
          ]
        });
      }
    } else if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
      var $slider = $('.buy-it-with-slider');
      
      // Destroy existing slider if initialized
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      
      if ($slider.length) {
        $slider.slick({
          dots: true,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                dots: true
              }
            }
          ]
        });
      }
    }
  };
  
  // Try multiple initialization times
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlick);
  } else {
    initSlick();
  }
  
  // Fallback initialization
  setTimeout(initSlick, 500);
  setTimeout(initSlick, 1500);
})();